import {HelperPlugin} from '@/plugins/helper'
import moment from 'moment-timezone'
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue2TouchEvents from 'vue2-touch-events'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import VuetifyConfirm from 'vuetify-confirm'

if (process.env.VUE_APP_STATE == 'production') {
    var consoleToSlack = require('console-to-slack')
    var slackUrl = '/api/slack_hook'
    consoleToSlack.init(slackUrl, 3)
}

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCxJW7G2uw-if--Ji2HSPoFHflf3L-mVrU',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)
        region: 'TH',
        language: 'th'
        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
})


Vue.config.productionTip = false

Vue.use(HelperPlugin)

Vue.use(Vue2TouchEvents)

Vue.use(VuetifyConfirm, {
    vuetify,
    buttonTrueText: 'ตกลง',
    buttonFalseText: 'ยกเลิก',
    buttonTrueColor: 'primary',
    buttonFalseColor: 'grey',
    buttonTrueFlat: false,
    buttonFalseFlat: true,
    color: 'warning',
    icon: 'warning',
    title: '',
    width: 350,
    property: '$confirm'
})

var app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

//app.$vuetify.theme.dark = true


export default {
    app
}